import  {fetchBagLocationInfo} from "../network/BagTrackingNetworkAPI"

export const BagTrackingReducer = (state, action) => {
    switch (action.type) {
        case 'RECEIVE_DATA':
            state.bagList = action.data.bagList ? action.data.bagList : {}
            state.loadingOverview = false
            return {...state}
        case 'LOAD_VIEW':
            fetchBagLocationInfo(action.data.dispatcher)
            return {...state}
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/components/devicemanagement/bagtracking/reducer/BagTrackingReducer.js